// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"app_loadingIndicator__1ZAvv","visible":"app_visible__3I7ZL","indicator":"app_indicator__12a4C","text":"app_text__1X07s"};